<template>
  <div>
    <RowCard
      :theme="theme"
      class="align-start py-4"
      style="position: relative; min-height: 100px"
    >
      <div :style="{ width: headers[0].width }" class="flex-center gap-4">
        <v-btn
          v-if="isOIC && item.status === 'Submitted1'"
          small
          icon
          @click="onEdit"
        >
          <Iconify icon="material-symbols:edit" size="15px"></Iconify>
        </v-btn>
        <v-btn small icon @click="onPreview">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
      </div>
      <div
        :style="{ width: headers[1].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.no }}
      </div>
      <div
        :style="{ width: headers[2].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.main_project?.fiscal_year }}
      </div>
      <div
        :style="{ width: headers[3].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div
          class="one-line mb-5"
          style="height: 20px"
          :class="[redText ? 'theme-color-seven' : 'black--text']"
        >
          <tooltip-text :text="item?.main_project?.name" />
        </div>
        <div
          v-if="item.main_project?.start_date && item.main_project?.end_date"
          class="one-line font-type-normal"
          style="height: 20px"
        >
          <tooltip-text
            :text="
              'ระยะเวลาเปิดรับโครงการ :' +
              toDateRangeFormat(
                item?.main_project.start_date,
                item?.main_project.end_date
              )
            "
          />
        </div>
      </div>
      <div
        :style="{ width: headers[4].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.region }}
      </div>
      <div :style="{ width: headers[5].width }">
        <div v-if="item.doc_type">
          {{ item.doc_type === "Final" ? "รายงานฉบับสมบูรณ์" : (item.progress_month + " เดือน") }}
        </div>
      </div>
      <div
        :style="{
          width: headers[6].width,
          color: statusColorSeparator(item.status),
        }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div v-if="item.status === 'Submitted'" class="d-flex gap-8">
          <Button height="36px" @onClick="onApproved"> Approved </Button>
        </div>
        <div v-else>
          {{ item.status }}
        </div>
      </div>
      <div :style="{ width: headers[7].width }"></div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify>
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex justify-space-between gap-12 theme-color-eight">
          <div style="min-width: 8%; max-width: 8%">ลำดับ</div>
          <div style="min-width: 82%; max-width: 82%">แผนงาน</div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div
          v-if="item.main_project && item.main_project.plan"
          class="d-flex flex-column gap-8"
        >
          <div v-for="(x, i) in item.main_project.plan" :key="i">
            <div class="d-flex justify-space-between align-center gap-12">
              <div style="min-width: 8%; max-width: 8%">
                {{ i + 1 }}
              </div>
              <div style="min-width: 82%; max-width: 82%">
                {{ x.plan_master?.plan_name_th }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat } from "../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "ReportFromRSPItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
    };
  },
  computed: {
    ...mapState({
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
  },
  methods: {
    onPreview() {
      this.$router.push({
        name: "FormA",
        query: { id: this.item.id, preview: true, doc_type: "progress" },
      });
    },
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Submitted1":
        case "Submitted2":
        case "Inception":
          this.theme = 5;
          return "#000";

        case "Approved":
          this.theme = 3;
          return "var(--theme-color-three)";

        default:
          return "#000";
      }
    },
    onEdit() {
      this.$router.push({ name: "FormA", query: { id: this.item.id } });
    },
    onApproved() {
      this.$emit("onApproved");
    },
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
